var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafeDining(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.845 31.998H0v-1.982h38.845v1.983zm-2.608-3.248H2.609a16.466 16.466 0 0112.57-16.368 4.25 4.25 0 018.487 0 16.5 16.5 0 0112.57 16.354v.014zM21.452 11.825a2.164 2.164 0 00-4.07 0c1.352-.17 2.72-.17 4.07 0zM33.085 26.81l1.391-.049a13.134 13.134 0 00-1.962-5.683c-2.692-4.578-5.488-5.566-5.606-5.635l-.46 1.322s2.435.883 4.87 5.03a12.063 12.063 0 011.767 5.015z",
    fill: "#3B415E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.788 2.202v.263c0 .288 0 .584.012.902.063 3.026.147 6.66-5.32 8.423a.755.755 0 01-.463 0c-5.466-1.764-5.382-5.397-5.32-8.423 0-.316.013-.614.013-.902v-.263c0-.216.188-.39.42-.39h.282c1.84 0 3.18-.47 4.343-1.52l.197-.18a.441.441 0 01.588 0l.197.18c1.162 1.052 2.502 1.52 4.343 1.52h.282a.436.436 0 01.3.112c.08.073.126.173.126.278zm-3.02 2.38l-.554-.527a.39.39 0 00-.522 0l-2.08 1.949-.805-.75a.397.397 0 00-.522 0l-.557.518a.332.332 0 00-.108.243c0 .09.04.178.108.242l1.625 1.5a.39.39 0 00.522 0l2.894-2.689a.328.328 0 000-.487z",
    fill: "#B0B3B4"
  })));
}
export default SvgSafeDining;